var path = 'app/scripts/modules/core/src/help/helpField.popover.html';
var html = "<div ng-mouseenter=\"$ctrl.popoverHovered()\"\n     ng-mouseleave=\"$ctrl.hidePopover(false)\"\n     ng-bind-html=\"$ctrl.contents.content\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/help/helpField.popover.html
// module id = 828
// module chunks = 0